import { render, staticRenderFns } from "./alquilerEspecifico.vue?vue&type=template&id=1b15a9ea&scoped=true&"
import script from "./alquilerEspecifico.vue?vue&type=script&lang=js&"
export * from "./alquilerEspecifico.vue?vue&type=script&lang=js&"
import style0 from "./alquilerEspecifico.vue?vue&type=style&index=0&id=1b15a9ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b15a9ea",
  null
  
)

export default component.exports